.container {
  display: flex;
  align-items: center;
}

.inner {
  position: relative;
  align-self: stretch;
  display: flex;
  align-items: center;
  margin-right: 0.35em;
  padding-left: 10px;
}

.country-select {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 1;
  border: 0;
  opacity: 0;
  cursor: pointer;
}

.country-icon {
  width: 1.5em;
  height: 1em;
  background-color: rgb(0 0 0 / 10%);
  box-shadow:
    0 0 0 1px rgb(0 0 0 / 50%),
    inset 0 0 0 1px rgb(0 0 0 / 50%);
}

.country-icon-img {
  display: block;
  width: 100%;
  height: 100%;
}

.arrow {
  display: block;
  content: "";
  width: 0.3em;
  height: 0.3em;
  margin-left: 0.35em;
  border-style: solid;
  border-color: currentcolor;
  border-width: 0 1px 1px 0;
  transform: rotate(45deg);

  /* opacity: 0.45; */
}

.input {
  flex: 1;
  border: 0;
  border-left: 1px solid var(--field-border);
  padding: 5px 6px;
  background-color: white;

  /* box-sizing: border-box; */

  /* color: var(--button-text); */

  /* min-width: 0; */

  /* width: 100%; */
}
